import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useCookies } from 'react-cookie';
import { Page } from '../../components/Page';
import { EmailLogin } from './EmailLogin';

const TERMS_URL = 'https://jupiterone.com/terms/';
const PRIVACY_POLICY_URL = 'https://jupiterone.com/privacy-policy/';

const LOGOUT_REASON_COOKIE_NAME = 'j1-logout-reason';

const useStyles = makeStyles(() => ({
  // The width the form had as the left column of the old two-column card.
  column: {
    width: 340,
  },
  agreementMessage: {
    marginTop: '1rem',
    textAlign: 'center',
    fontSize: 'var(--text-caption)',
    lineHeight: 'var(--text-caption--line-height)',
    color: 'var(--fg-muted)',
  },
  agreementLink: {
    color: 'var(--fg-heading)',
    fontWeight: 500,
    textDecoration: 'none',
    textUnderlineOffset: '4px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export function LoginForm() {
  const classes = useStyles();

  // logout reason message passed through cookies
  const [cookies] = useCookies([LOGOUT_REASON_COOKIE_NAME]);

  return (
    <Page
      title="Sign In"
      message={
        cookies[LOGOUT_REASON_COOKIE_NAME] === 'sessionTimeout'
          ? 'Your session has timed out. Please sign in again.'
          : null
      }
    >
      <Box className={classes.column}>
        <EmailLogin />
        <Typography className={classes.agreementMessage}>
          By logging in you are agreeing to JupiterOne&apos;s <br />
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noreferrer"
            className={classes.agreementLink}
          >
            Terms and Conditions
          </a>{' '}
          &{' '}
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noreferrer"
            className={classes.agreementLink}
          >
            Privacy Policy
          </a>
        </Typography>
      </Box>
    </Page>
  );
}
